/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {DateTimeFieldViewer} from "../../../Models/Core/FieldViewers/DateTimeFieldViewer";
import React from "react";
import {ContextNodeLink} from "../../../Components/Common/ContextNodeLink";

export const ContextNodeWithDateTimeFieldViewer = (props) => {
	const {contextNodeId, date} = props;
	if(!contextNodeId) {
		return <div>(None Specified)</div>;
	}
	
	return <div className="inline-field-viewer">{[
		contextNodeId && <ContextNodeLink key={1} contextNodeId={contextNodeId} />,
		contextNodeId && date && <span key={2}>at</span>,
		date && <DateTimeFieldViewer key={3} Value={date}/>,
	].filter(Boolean)}
	</div>;
};
